import React, { Fragment, useState } from 'react';
//import history from '../../../';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Delete from '@material-ui/icons/DeleteOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import CloseIcon from '@material-ui/icons/Close';
import MonetizationOn from '@material-ui/icons/MonetizationOn';
import ModalAlert from '../../../shared/components/Modal';
import Modal from '@material-ui/core/Modal';
import ModalMat from '@material-ui/core/Modal';
import RepeatIcon from '@material-ui/icons/Repeat';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import ImageIcon from '@material-ui/icons/Image';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faHandHoldingDollar } from "@fortawesome/free-solid-svg-icons";
import pdfDetailAdvacePaymentData from './pdfDetailAdvacePaymentData';//
import ModalFormAddPaymentToInvoices from './AddAdvancePaymentToInvoice/ModalFormAddPaymentToInvoices';

const ReactTableActionsAdvance = ({ data, refresh, setOnEdit, setAdvanceToEdit }) => {

    const [isDelete, setIsdeleted] = useState(false);
    const [showAdvancePDF, setShowAdvancePDF] = useState(false);
    const [showFormAddPaymentsToInvoice, setShowFormAddPaymentsToInvoice] = useState(false);
    const urlLogo = sessionStorage.getItem('logoURL');
    const profile = JSON.parse(sessionStorage.getItem('clinica'));
    const user = JSON.parse(sessionStorage.getItem('usuario'));

    const onToggleToEditAdvance = (advance) => {
        setOnEdit(true);
        setAdvanceToEdit(advance);
    }

    const printPDFAdvance = (advanceToPtint) => {
        let data = {
            infoAdvance: advanceToPtint,
            profile: profile,
            urlLogo: urlLogo,
            user: user
        }

        setShowAdvancePDF(true);
        pdfDetailAdvacePaymentData(data);
    }

    const onDelet = () => {
        setIsdeleted(false);
        let dataSend = { id_anticipo: data.data.original.id_anticipo };
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'anticipo/delete', {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then(response => {
                    console.log(response);
                    refresh();
                    return response.json();
                })
                .then(data => {
                    resolve(true);
                })
                .catch((error) => {
                    resolve(error);
                });
        })
    }

    return (<Fragment>
        <td role="cell">

            <Tooltip title="Editar">
                <IconButton aria-label="edit" onClick={() => {
                    onToggleToEditAdvance(data.data.original);
                }}>
                    <EditOutlinedIcon />
                </IconButton>
            </Tooltip>
            <Tooltip title="Asignar Anticipo a Facturas">
                <IconButton aria-label="edit" onClick={() => {
                    //onToggleToEditAdvance(data.data.original)
                    setShowFormAddPaymentsToInvoice(true);
                }}>
                    <FontAwesomeIcon icon={faHandHoldingDollar} />
                </IconButton>
            </Tooltip>
            <Tooltip title="Ver PDF">
                <IconButton
                    aria-label="edit"
                    onClick={() => {
                        printPDFAdvance(data.data.original);
                    }}>
                    <FontAwesomeIcon icon={faFilePdf} />
                </IconButton>
            </Tooltip>
            <Tooltip title="">
                <IconButton aria-label="delete" onClick={() => {
                    setIsdeleted(true);
                }}>
                    <DeleteForeverIcon />
                </IconButton>
            </Tooltip>
            {isDelete ?
                <ModalAlert
                    color={'warning'}
                    title={"Seguro"}
                    message={"¿Deseas eliminar este Anticipo?"}
                    modal={isDelete}
                    onOk={onDelet}
                    toggle={() => { setIsdeleted(!isDelete) }}
                />
                : null}
        </td>
        {showAdvancePDF ?
            <Modal
                open={showAdvancePDF}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '80%', margin: 10, height: '80%' }}>
                    <IconButton style={{ float: 'right' }} onClick={() => {
                        setShowAdvancePDF(false);
                    }}>
                        <CloseIcon />
                    </IconButton>
                    <iframe id="pdfV" width="100%" height="90%" title="pdf-report" >
                    </iframe>
                </div>
            </Modal>
            : null}
            {showFormAddPaymentsToInvoice ? <ModalFormAddPaymentToInvoices advancedPayment={data.data.original} isOpen={showFormAddPaymentsToInvoice} setIsOpen={setShowFormAddPaymentsToInvoice}/> : null }
    </Fragment>)
}

export default ReactTableActionsAdvance;